import { render, staticRenderFns } from "./_alize.vue?vue&type=template&id=0e4a98bc&lang=pug&"
import script from "./_alize.vue?vue&type=script&lang=js&"
export * from "./_alize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports